






import { Component, Vue } from 'vue-property-decorator'
import { MediaQuery, MediaQueryChangeEvent, MediaQueryService } from '@workbench/core'
import { getOneWebLocale, setJWE } from '@/services/oneweb'
import { initAssetServer } from '@/__webpack_public_path__'
import VueI18n from 'vue-i18n'
import i18n from './i18n'
import SlotReachmeEntry from '@/components/slot-reachme-entry/slot-reachme-entry.vue'
import SlotReachmeIcon from '@/components/slot-reachme-icon/slot-reachme-icon.vue'
import NotificationsHubContent from './components/notifications-hub-content/notifications-hub-content.vue'
import store, { initialState, updateState } from './store'
import { StoreState } from './store/interfaces'
import { closeStreams, isMobileScreen, openStreams } from './services/utils'
import { AUTHENTICATION_CONNECTION, AuthenticationState, isLoggedIn, getJwe } from '@b2x/authentication-library'
import { initializeStore, SeamlessCoreStore } from '@seamless/store'

Vue.use(VueI18n)
initAssetServer()
Vue.config.ignoredElements = [/wb-w*/]

@Component({
  i18n,
  components: {
    SlotReachmeEntry,
    SlotReachmeIcon,
    NotificationsHubContent,
  },
})
export default class App extends Vue {
  unsubscribe: any = null
  isLoggedIn = false
  isStandaloneMode = (window as any).notificationsHubStandaloneMode
  breakpoint = new MediaQueryService(window).getCurrentMediaQuery()
  isMobile = isMobileScreen(this.breakpoint)
  state: StoreState = initialState
  seamlessStore!: SeamlessCoreStore

  async beforeMount(): Promise<void> {
    this.seamlessStore = initializeStore()
    if (this.isStandaloneMode) {
      this.isLoggedIn = true
      this.initApp()
    } else {
      this.seamlessStore.subscribe(AUTHENTICATION_CONNECTION, (state: AuthenticationState) => {
        const b2xLoggedIn = isLoggedIn(state)
        if (b2xLoggedIn !== this.isLoggedIn) {
          this.isLoggedIn = b2xLoggedIn
          if (b2xLoggedIn === true) {
            this.initApp(getJwe(state))
          }
        }
      })
    }
  }

  created(): void {
    /* eslint-disable no-undef */
    window.addEventListener('wbresize', ((event: CustomEvent<MediaQueryChangeEvent>): void =>
      this.setScreen(event.detail.current)) as EventListener),
      document.addEventListener('visibilitychange', this.manageStreamConnection)
  }

  private async initApp(jwe?: string | null): Promise<void> {
    setJWE(jwe ?? sessionStorage.getItem('ow_aem_jwe'))
    this.$i18n.locale = await getOneWebLocale()
    store.subscribe(() => (this.state = updateState(store.getState())))
  }

  private manageStreamConnection(): void {
    document.hidden ? closeStreams() : openStreams()
  }

  private setScreen(breakpoint: MediaQuery): void {
    this.isMobile = isMobileScreen(breakpoint)
  }

  beforeDestroy(): void {
    this.unsubscribe()
    document.removeEventListener('visibilitychange', this.manageStreamConnection)
    /* eslint-disable no-undef */
    window.removeEventListener('wbresize', ((event: CustomEvent<MediaQueryChangeEvent>): void =>
      this.setScreen(event.detail.current)) as EventListener)
  }
}
